module.exports = __webpack_public_path__ + "img/中文版_库尔_河北.7d96bfad.webp";